import { render, staticRenderFns } from "./SeriesDetailsComponent.vue?vue&type=template&id=d2290c56&"
import script from "./SeriesDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./SeriesDetailsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports